import localStoreUtil from "../ApiSetUp/localstore.util";
import { useAppSelector } from "../Redux/app/hooks";
export { ALL_SECTIONS, PATH_SECTION } from "./sections";

export function getUserData() {
  try {
    return JSON.parse(localStoreUtil?.get_data("User_Data") || "null");
  } catch {
    return null;
  }
}

/** Superuser = userType 1 only. Role string is a display label. */
export function isSuperuser(user = getUserData()) {
  return user?.userType === 1;
}

export function useSectionPerm(section) {
  const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
  const superuser = isSuperuser();
  return {
    isAdmin: superuser,
    isSuperuser: superuser,
    canView: superuser || getPermissionList?.viewPermission?.includes(section) || getPermissionList?.editPermission?.includes(section),
    canEdit: superuser || getPermissionList?.editPermission?.includes(section),
  };
}
